export const BUTTON_CONTAINER_ELEMENT_WIDTH = '300';
export const BUTTON_CONTAINER_ELEMENT_ID = 'google_sign_in_button_container';
export const GIS_CLIENT_SCRIPT_ELEMENT_ID = 'google_gsi_client';
export const GIS_LINK_ELEMENT_ID = 'googleidentityservice';
export const GIS_BUTTON_STYLE_ELEMENT_ID =
  'googleidentityservice_button_styles';
